/* eslint-disable */
// biome-ignore-all lint: auto-generated
// biome-ignore-all format: auto-generated
// biome-ignore-all assist: auto-generated
//
// This file is auto-generated by build/build.js.
// Do not modify manually, please do: bun run build:minimap.
//

import { DefaultMinimap as M } from "./DefaultMinimap"

export const RenameMap = {
  fd_close: M.fd_close,
  fd_write: M.fd_write,
  fd_read: M.fd_read,
  fd_seek: M.fd_seek,
  environ_get: M.environ_get,
  environ_sizes_get: M.environ_sizes_get,
  proc_exit: M.proc_exit,
  fd_pread: M.fd_pread,
  fd_pwrite: M.fd_pwrite,
  clock_time_get: M.clock_time_get,
  _tzset_js: M._tzset_js,
  _localtime_js: M._localtime_js,
  _gmtime_js: M._gmtime_js,
  __syscall_fcntl64: M.__syscall_fcntl64,
  __syscall_ioctl: M.__syscall_ioctl,
  __syscall_openat: M.__syscall_openat,
  __syscall_stat64: M.__syscall_stat64,
  __syscall_unlinkat: M.__syscall_unlinkat,
  __syscall_rmdir: M.__syscall_rmdir,
  __syscall_getdents64: M.__syscall_getdents64,
  _emscripten_runtime_keepalive_clear: M._emscripten_runtime_keepalive_clear,
  _setitimer_js: M._setitimer_js,
  emscripten_resize_heap: M.emscripten_resize_heap,
  emscripten_date_now: M.emscripten_date_now,
  _abort_js: M._abort_js,
  _emscripten_throw_longjmp: M._emscripten_throw_longjmp,
  __syscall_getcwd: M.__syscall_getcwd,
  __assert_fail: M.__assert_fail,
  __syscall_dup: M.__syscall_dup,
  __syscall_dup3: M.__syscall_dup3,
  __syscall_fstat64: M.__syscall_fstat64,
  __syscall_lstat64: M.__syscall_lstat64,
  __syscall_newfstatat: M.__syscall_newfstatat,
  __syscall_renameat: M.__syscall_renameat,
  __cxa_throw: M.__cxa_throw,
  exit: M.exit,
  log_str: M.log_str,
  env: M.env,
  wasi_snapshot_preview1: M.wasi_snapshot_preview1,
  memory: M.memory,
  __indirect_function_table: M.__indirect_function_table,
  __wasm_call_ctors: M.__wasm_call_ctors,
  setThrew: M.setThrew,
  emscripten_stack_get_current: M.emscripten_stack_get_current,
  _emscripten_stack_restore: M._emscripten_stack_restore,
  malloc: M.malloc,
  free: M.free,
  invoke_ii: M.invoke_ii,
  invoke_iii: M.invoke_iii,
  invoke_iiii: M.invoke_iiii,
  invoke_iiiii: M.invoke_iiiii,
  invoke_iiiiii: M.invoke_iiiiii,
  invoke_iiiiiii: M.invoke_iiiiiii,
  invoke_iiiiiiii: M.invoke_iiiiiiii,
  invoke_iiiiiiiii: M.invoke_iiiiiiiii,
  invoke_iiiiiiiiii: M.invoke_iiiiiiiiii,
  invoke_iiiiiiiiiiii: M.invoke_iiiiiiiiiiii,
  invoke_v: M.invoke_v,
  invoke_vi: M.invoke_vi,
  invoke_vii: M.invoke_vii,
  invoke_viii: M.invoke_viii,
  invoke_viiii: M.invoke_viiii,
  invoke_viiiii: M.invoke_viiiii,
  invoke_viiiiii: M.invoke_viiiiii,
  invoke_viiiiiii: M.invoke_viiiiiii,
  invoke_viiiiiiii: M.invoke_viiiiiiii,
  invoke_viiiiiiiii: M.invoke_viiiiiiiii,
  invoke_iiji: M.invoke_iiji,
  invoke_iji: M.invoke_iji,
  invoke_jji: M.invoke_jji,
  invoke_jiji: M.invoke_jiji,
  invoke_iij: M.invoke_iij,
  invoke_jii: M.invoke_jii,
  invoke_ji: M.invoke_ji,
  invoke_diiid: M.invoke_diiid,
  invoke_iidi: M.invoke_iidi,
  invoke_iddii: M.invoke_iddii,
  invoke_iiiiiij: M.invoke_iiiiiij,
  invoke_iiiiiiiiiijj: M.invoke_iiiiiiiiiijj,
  invoke_iiiiiiiiiiji: M.invoke_iiiiiiiiiiji,
  invoke_iiiiiiijjii: M.invoke_iiiiiiijjii,
  invoke_iijiii: M.invoke_iijiii,
  invoke_iiijiii: M.invoke_iiijiii,
  invoke_iiiijj: M.invoke_iiiijj,
  invoke_iidiii: M.invoke_iidiii,
  invoke_fdi: M.invoke_fdi,
  invoke_idii: M.invoke_idii,
  invoke_iiiiiiiifi: M.invoke_iiiiiiiifi,
  invoke_vijii: M.invoke_vijii,
  invoke_iiiijii: M.invoke_iiiijii,
  invoke_iiiiijiiiii: M.invoke_iiiiijiiiii,
  invoke_fdii: M.invoke_fdii,
  invoke_viiiiiiiiijiiii: M.invoke_viiiiiiiiijiiii,
  invoke_id: M.invoke_id,
  invoke_dd: M.invoke_dd,
  invoke_viij: M.invoke_viij,
  invoke_fdd: M.invoke_fdd,
  invoke_iiiij: M.invoke_iiiij,
  invoke_iiiiijiiii: M.invoke_iiiiijiiii,
  invoke_iiijii: M.invoke_iiijii,
  invoke_iiiijiiii: M.invoke_iiiijiiii,
  invoke_iiiji: M.invoke_iiiji,
  invoke_iidiiii: M.invoke_iidiiii,
  invoke_iijii: M.invoke_iijii,
  invoke_iijj: M.invoke_iijj,
  invoke_iijjjjjj: M.invoke_iijjjjjj,
  invoke_viiiiiiiiiiiiiijiiiii: M.invoke_viiiiiiiiiiiiiijiiiii,
  invoke_viiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiijiiiiii: M.invoke_viiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiijiiiiii,
  invoke_iiiiiiiiiiiiiiiii: M.invoke_iiiiiiiiiiiiiiiii,
  invoke_iiiiiiiiiiiiii: M.invoke_iiiiiiiiiiiiii,
  invoke_iiiiiiiiiiiii: M.invoke_iiiiiiiiiiiii,
  invoke_iiiiiiiiiiiiiiii: M.invoke_iiiiiiiiiiiiiiii,
  invoke_iiiiiiiiiii: M.invoke_iiiiiiiiiii,
  invoke_iiiiiiiiiiiiiii: M.invoke_iiiiiiiiiiiiiii,
  invoke_djijd: M.invoke_djijd,
  invoke_fdj: M.invoke_fdj,
  invoke_fdjj: M.invoke_fdjj,
  invoke_iddjj: M.invoke_iddjj,
  invoke_idjj: M.invoke_idjj,
  invoke_iidjjj: M.invoke_iidjjj,
  invoke_iijjj: M.invoke_iijjj,
  invoke_ij: M.invoke_ij,
  invoke_ijdj: M.invoke_ijdj,
  invoke_ijii: M.invoke_ijii,
  invoke_ijiii: M.invoke_ijiii,
  invoke_ijiiii: M.invoke_ijiiii,
  invoke_ijiiiiiii: M.invoke_ijiiiiiii,
  invoke_ijiiiiiiji: M.invoke_ijiiiiiiji,
  invoke_ijiiiij: M.invoke_ijiiiij,
  invoke_ijiiiijiii: M.invoke_ijiiiijiii,
  invoke_ijiiiijij: M.invoke_ijiiiijij,
  invoke_ijiiij: M.invoke_ijiiij,
  invoke_ijiiijjiiiiii: M.invoke_ijiiijjiiiiii,
  invoke_ijiij: M.invoke_ijiij,
  invoke_ijiiji: M.invoke_ijiiji,
  invoke_ijiijj: M.invoke_ijiijj,
  invoke_ijij: M.invoke_ijij,
  invoke_ijiji: M.invoke_ijiji,
  invoke_ijijijj: M.invoke_ijijijj,
  invoke_ijijj: M.invoke_ijijj,
  invoke_ijijjj: M.invoke_ijijjj,
  invoke_ijijjjj: M.invoke_ijijjjj,
  invoke_ijj: M.invoke_ijj,
  invoke_ijji: M.invoke_ijji,
  invoke_ijjii: M.invoke_ijjii,
  invoke_ijjiiiij: M.invoke_ijjiiiij,
  invoke_ijjiiiijjii: M.invoke_ijjiiiijjii,
  invoke_ijjiiij: M.invoke_ijjiiij,
  invoke_ijjiiijjji: M.invoke_ijjiiijjji,
  invoke_ijjiij: M.invoke_ijjiij,
  invoke_ijjiijiiii: M.invoke_ijjiijiiii,
  invoke_ijjiijiiiii: M.invoke_ijjiijiiiii,
  invoke_ijjiijiiiiji: M.invoke_ijjiijiiiiji,
  invoke_ijjiijiiiijii: M.invoke_ijjiijiiiijii,
  invoke_ijjiijiiiijiij: M.invoke_ijjiijiiiijiij,
  invoke_ijjiijiiiijj: M.invoke_ijjiijiiiijj,
  invoke_ijjiijjjjiiiiiiii: M.invoke_ijjiijjjjiiiiiiii,
  invoke_ijjiijjjjjjjiiii: M.invoke_ijjiijjjjjjjiiii,
  invoke_ijjij: M.invoke_ijjij,
  invoke_ijjiji: M.invoke_ijjiji,
  invoke_ijjijiii: M.invoke_ijjijiii,
  invoke_ijjijj: M.invoke_ijjijj,
  invoke_ijjijjj: M.invoke_ijjijjj,
  invoke_ijjj: M.invoke_ijjj,
  invoke_ijjji: M.invoke_ijjji,
  invoke_ijjjii: M.invoke_ijjjii,
  invoke_ijjjiiiiiiii: M.invoke_ijjjiiiiiiii,
  invoke_ijjjiiiji: M.invoke_ijjjiiiji,
  invoke_ijjjiiijj: M.invoke_ijjjiiijj,
  invoke_ijjjij: M.invoke_ijjjij,
  invoke_ijjjijj: M.invoke_ijjjijj,
  invoke_ijjjijji: M.invoke_ijjjijji,
  invoke_ijjjj: M.invoke_ijjjj,
  invoke_ijjjji: M.invoke_ijjjji,
  invoke_ijjjjii: M.invoke_ijjjjii,
  invoke_ijjjjj: M.invoke_ijjjjj,
  invoke_ijjjjji: M.invoke_ijjjjji,
  invoke_ijjjjjij: M.invoke_ijjjjjij,
  invoke_ijjjjjj: M.invoke_ijjjjjj,
  invoke_ijjjjjji: M.invoke_ijjjjjji,
  invoke_ijjjjjjiij: M.invoke_ijjjjjjiij,
  invoke_ijjjjjjijii: M.invoke_ijjjjjjijii,
  invoke_ijjjjjjj: M.invoke_ijjjjjjj,
  invoke_ijjjjjjjfj: M.invoke_ijjjjjjjfj,
  invoke_ijjjjjjjj: M.invoke_ijjjjjjjj,
  invoke_ijjjjjjjji: M.invoke_ijjjjjjjji,
  invoke_ijjjjjjjjj: M.invoke_ijjjjjjjjj,
  invoke_ijjjjjjjjjj: M.invoke_ijjjjjjjjjj,
  invoke_ijjjjjjjjjjj: M.invoke_ijjjjjjjjjjj,
  invoke_ijjjjjjjjjjjjj: M.invoke_ijjjjjjjjjjjjj,
  invoke_ijjjjjjjjjjjjjj: M.invoke_ijjjjjjjjjjjjjj,
  invoke_jj: M.invoke_jj,
  invoke_jjii: M.invoke_jjii,
  invoke_jjiii: M.invoke_jjiii,
  invoke_jjiiiii: M.invoke_jjiiiii,
  invoke_jjiijj: M.invoke_jjiijj,
  invoke_jjij: M.invoke_jjij,
  invoke_jjijjjji: M.invoke_jjijjjji,
  invoke_jjj: M.invoke_jjj,
  invoke_jjji: M.invoke_jjji,
  invoke_jjjiii: M.invoke_jjjiii,
  invoke_jjjiijjj: M.invoke_jjjiijjj,
  invoke_jjjj: M.invoke_jjjj,
  invoke_jjjji: M.invoke_jjjji,
  invoke_jjjjiijii: M.invoke_jjjjiijii,
  invoke_jjjjj: M.invoke_jjjjj,
  invoke_jjjjji: M.invoke_jjjjji,
  invoke_jjjjjj: M.invoke_jjjjjj,
  invoke_viiiiiijji: M.invoke_viiiiiijji,
  invoke_viiiijjjij: M.invoke_viiiijjjij,
  invoke_viiijjji: M.invoke_viiijjji,
  invoke_viijj: M.invoke_viijj,
  invoke_viijjiiiiiiijiijiiiii: M.invoke_viijjiiiiiiijiijiiiii,
  invoke_vijjj: M.invoke_vijjj,
  invoke_vijjji: M.invoke_vijjji,
  invoke_vijjjij: M.invoke_vijjjij,
  invoke_vj: M.invoke_vj,
  invoke_vji: M.invoke_vji,
  invoke_vjii: M.invoke_vjii,
  invoke_vjiiii: M.invoke_vjiiii,
  invoke_vjiiiiiiiiiiijjiiijiiijijijjiiiiijiiiijj: M.invoke_vjiiiiiiiiiiijjiiijiiijijijjiiiiijiiiijj,
  invoke_vjiiiiiiiijjjjj: M.invoke_vjiiiiiiiijjjjj,
  invoke_vjiiiij: M.invoke_vjiiiij,
  invoke_vjiij: M.invoke_vjiij,
  invoke_vjiijiii: M.invoke_vjiijiii,
  invoke_vjiijj: M.invoke_vjiijj,
  invoke_vjij: M.invoke_vjij,
  invoke_vjijj: M.invoke_vjijj,
  invoke_vjijjjj: M.invoke_vjijjjj,
  invoke_vjj: M.invoke_vjj,
  invoke_vjji: M.invoke_vjji,
  invoke_vjjii: M.invoke_vjjii,
  invoke_vjjiii: M.invoke_vjjiii,
  invoke_vjjiiiijj: M.invoke_vjjiiiijj,
  invoke_vjjiiij: M.invoke_vjjiiij,
  invoke_vjjiiijj: M.invoke_vjjiiijj,
  invoke_vjjij: M.invoke_vjjij,
  invoke_vjjiji: M.invoke_vjjiji,
  invoke_vjjijj: M.invoke_vjjijj,
  invoke_vjjj: M.invoke_vjjj,
  invoke_vjjji: M.invoke_vjjji,
  invoke_vjjjii: M.invoke_vjjjii,
  invoke_vjjjiii: M.invoke_vjjjiii,
  invoke_vjjjijji: M.invoke_vjjjijji,
  invoke_vjjjj: M.invoke_vjjjj,
  invoke_vjjjji: M.invoke_vjjjji,
  invoke_vjjjjii: M.invoke_vjjjjii,
  invoke_vjjjjiij: M.invoke_vjjjjiij,
  invoke_vjjjjiijj: M.invoke_vjjjjiijj,
  invoke_vjjjjij: M.invoke_vjjjjij,
  invoke_vjjjjj: M.invoke_vjjjjj,
  dynCall_ii: M.dynCall_ii,
  dynCall_iii: M.dynCall_iii,
  dynCall_iiii: M.dynCall_iiii,
  dynCall_iiiii: M.dynCall_iiiii,
  dynCall_iiiiii: M.dynCall_iiiiii,
  dynCall_iiiiiii: M.dynCall_iiiiiii,
  dynCall_iiiiiiii: M.dynCall_iiiiiiii,
  dynCall_iiiiiiiii: M.dynCall_iiiiiiiii,
  dynCall_iiiiiiiiii: M.dynCall_iiiiiiiiii,
  dynCall_iiiiiiiiiiii: M.dynCall_iiiiiiiiiiii,
  dynCall_v: M.dynCall_v,
  dynCall_vi: M.dynCall_vi,
  dynCall_vii: M.dynCall_vii,
  dynCall_viii: M.dynCall_viii,
  dynCall_viiii: M.dynCall_viiii,
  dynCall_viiiii: M.dynCall_viiiii,
  dynCall_viiiiii: M.dynCall_viiiiii,
  dynCall_viiiiiii: M.dynCall_viiiiiii,
  dynCall_viiiiiiii: M.dynCall_viiiiiiii,
  dynCall_viiiiiiiii: M.dynCall_viiiiiiiii,
  dynCall_iiji: M.dynCall_iiji,
  dynCall_iji: M.dynCall_iji,
  dynCall_jji: M.dynCall_jji,
  dynCall_jiji: M.dynCall_jiji,
  dynCall_iij: M.dynCall_iij,
  dynCall_jii: M.dynCall_jii,
  dynCall_ji: M.dynCall_ji,
  dynCall_diiid: M.dynCall_diiid,
  dynCall_iidi: M.dynCall_iidi,
  dynCall_iddii: M.dynCall_iddii,
  dynCall_iiiiiij: M.dynCall_iiiiiij,
  dynCall_iiiiiiiiiijj: M.dynCall_iiiiiiiiiijj,
  dynCall_iiiiiiiiiiji: M.dynCall_iiiiiiiiiiji,
  dynCall_iiiiiiijjii: M.dynCall_iiiiiiijjii,
  dynCall_iijiii: M.dynCall_iijiii,
  dynCall_iiijiii: M.dynCall_iiijiii,
  dynCall_iiiijj: M.dynCall_iiiijj,
  dynCall_iidiii: M.dynCall_iidiii,
  dynCall_fdi: M.dynCall_fdi,
  dynCall_idii: M.dynCall_idii,
  dynCall_iiiiiiiifi: M.dynCall_iiiiiiiifi,
  dynCall_vijii: M.dynCall_vijii,
  dynCall_iiiijii: M.dynCall_iiiijii,
  dynCall_iiiiijiiiii: M.dynCall_iiiiijiiiii,
  dynCall_fdii: M.dynCall_fdii,
  dynCall_viiiiiiiiijiiii: M.dynCall_viiiiiiiiijiiii,
  dynCall_id: M.dynCall_id,
  dynCall_dd: M.dynCall_dd,
  dynCall_viij: M.dynCall_viij,
  dynCall_fdd: M.dynCall_fdd,
  dynCall_iiiij: M.dynCall_iiiij,
  dynCall_iiiiijiiii: M.dynCall_iiiiijiiii,
  dynCall_iiijii: M.dynCall_iiijii,
  dynCall_iiiijiiii: M.dynCall_iiiijiiii,
  dynCall_iiiji: M.dynCall_iiiji,
  dynCall_iidiiii: M.dynCall_iidiiii,
  dynCall_iijii: M.dynCall_iijii,
  dynCall_iijj: M.dynCall_iijj,
  dynCall_iijjjjjj: M.dynCall_iijjjjjj,
  dynCall_viiiiiiiiiiiiiijiiiii: M.dynCall_viiiiiiiiiiiiiijiiiii,
  dynCall_viiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiijiiiiii: M.dynCall_viiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiijiiiiii,
  dynCall_iiiiiiiiiiiiiiiii: M.dynCall_iiiiiiiiiiiiiiiii,
  dynCall_iiiiiiiiiiiiii: M.dynCall_iiiiiiiiiiiiii,
  dynCall_iiiiiiiiiiiii: M.dynCall_iiiiiiiiiiiii,
  dynCall_iiiiiiiiiiiiiiii: M.dynCall_iiiiiiiiiiiiiiii,
  dynCall_iiiiiiiiiii: M.dynCall_iiiiiiiiiii,
  dynCall_iiiiiiiiiiiiiii: M.dynCall_iiiiiiiiiiiiiii,
  dynCall_djijd: M.dynCall_djijd,
  dynCall_fdj: M.dynCall_fdj,
  dynCall_fdjj: M.dynCall_fdjj,
  dynCall_iddjj: M.dynCall_iddjj,
  dynCall_idjj: M.dynCall_idjj,
  dynCall_iidjjj: M.dynCall_iidjjj,
  dynCall_iijjj: M.dynCall_iijjj,
  dynCall_ij: M.dynCall_ij,
  dynCall_ijdj: M.dynCall_ijdj,
  dynCall_ijii: M.dynCall_ijii,
  dynCall_ijiii: M.dynCall_ijiii,
  dynCall_ijiiii: M.dynCall_ijiiii,
  dynCall_ijiiiiiii: M.dynCall_ijiiiiiii,
  dynCall_ijiiiiiiji: M.dynCall_ijiiiiiiji,
  dynCall_ijiiiij: M.dynCall_ijiiiij,
  dynCall_ijiiiijiii: M.dynCall_ijiiiijiii,
  dynCall_ijiiiijij: M.dynCall_ijiiiijij,
  dynCall_ijiiij: M.dynCall_ijiiij,
  dynCall_ijiiijjiiiiii: M.dynCall_ijiiijjiiiiii,
  dynCall_ijiij: M.dynCall_ijiij,
  dynCall_ijiiji: M.dynCall_ijiiji,
  dynCall_ijiijj: M.dynCall_ijiijj,
  dynCall_ijij: M.dynCall_ijij,
  dynCall_ijiji: M.dynCall_ijiji,
  dynCall_ijijijj: M.dynCall_ijijijj,
  dynCall_ijijj: M.dynCall_ijijj,
  dynCall_ijijjj: M.dynCall_ijijjj,
  dynCall_ijijjjj: M.dynCall_ijijjjj,
  dynCall_ijj: M.dynCall_ijj,
  dynCall_ijji: M.dynCall_ijji,
  dynCall_ijjii: M.dynCall_ijjii,
  dynCall_ijjiiiij: M.dynCall_ijjiiiij,
  dynCall_ijjiiiijjii: M.dynCall_ijjiiiijjii,
  dynCall_ijjiiij: M.dynCall_ijjiiij,
  dynCall_ijjiiijjji: M.dynCall_ijjiiijjji,
  dynCall_ijjiij: M.dynCall_ijjiij,
  dynCall_ijjiijiiii: M.dynCall_ijjiijiiii,
  dynCall_ijjiijiiiii: M.dynCall_ijjiijiiiii,
  dynCall_ijjiijiiiiji: M.dynCall_ijjiijiiiiji,
  dynCall_ijjiijiiiijii: M.dynCall_ijjiijiiiijii,
  dynCall_ijjiijiiiijiij: M.dynCall_ijjiijiiiijiij,
  dynCall_ijjiijiiiijj: M.dynCall_ijjiijiiiijj,
  dynCall_ijjiijjjjiiiiiiii: M.dynCall_ijjiijjjjiiiiiiii,
  dynCall_ijjiijjjjjjjiiii: M.dynCall_ijjiijjjjjjjiiii,
  dynCall_ijjij: M.dynCall_ijjij,
  dynCall_ijjiji: M.dynCall_ijjiji,
  dynCall_ijjijiii: M.dynCall_ijjijiii,
  dynCall_ijjijj: M.dynCall_ijjijj,
  dynCall_ijjijjj: M.dynCall_ijjijjj,
  dynCall_ijjj: M.dynCall_ijjj,
  dynCall_ijjji: M.dynCall_ijjji,
  dynCall_ijjjii: M.dynCall_ijjjii,
  dynCall_ijjjiiiiiiii: M.dynCall_ijjjiiiiiiii,
  dynCall_ijjjiiiji: M.dynCall_ijjjiiiji,
  dynCall_ijjjiiijj: M.dynCall_ijjjiiijj,
  dynCall_ijjjij: M.dynCall_ijjjij,
  dynCall_ijjjijj: M.dynCall_ijjjijj,
  dynCall_ijjjijji: M.dynCall_ijjjijji,
  dynCall_ijjjj: M.dynCall_ijjjj,
  dynCall_ijjjji: M.dynCall_ijjjji,
  dynCall_ijjjjii: M.dynCall_ijjjjii,
  dynCall_ijjjjj: M.dynCall_ijjjjj,
  dynCall_ijjjjji: M.dynCall_ijjjjji,
  dynCall_ijjjjjij: M.dynCall_ijjjjjij,
  dynCall_ijjjjjj: M.dynCall_ijjjjjj,
  dynCall_ijjjjjji: M.dynCall_ijjjjjji,
  dynCall_ijjjjjjiij: M.dynCall_ijjjjjjiij,
  dynCall_ijjjjjjijii: M.dynCall_ijjjjjjijii,
  dynCall_ijjjjjjj: M.dynCall_ijjjjjjj,
  dynCall_ijjjjjjjfj: M.dynCall_ijjjjjjjfj,
  dynCall_ijjjjjjjj: M.dynCall_ijjjjjjjj,
  dynCall_ijjjjjjjji: M.dynCall_ijjjjjjjji,
  dynCall_ijjjjjjjjj: M.dynCall_ijjjjjjjjj,
  dynCall_ijjjjjjjjjj: M.dynCall_ijjjjjjjjjj,
  dynCall_ijjjjjjjjjjj: M.dynCall_ijjjjjjjjjjj,
  dynCall_ijjjjjjjjjjjjj: M.dynCall_ijjjjjjjjjjjjj,
  dynCall_ijjjjjjjjjjjjjj: M.dynCall_ijjjjjjjjjjjjjj,
  dynCall_jj: M.dynCall_jj,
  dynCall_jjii: M.dynCall_jjii,
  dynCall_jjiii: M.dynCall_jjiii,
  dynCall_jjiiiii: M.dynCall_jjiiiii,
  dynCall_jjiijj: M.dynCall_jjiijj,
  dynCall_jjij: M.dynCall_jjij,
  dynCall_jjijjjji: M.dynCall_jjijjjji,
  dynCall_jjj: M.dynCall_jjj,
  dynCall_jjji: M.dynCall_jjji,
  dynCall_jjjiii: M.dynCall_jjjiii,
  dynCall_jjjiijjj: M.dynCall_jjjiijjj,
  dynCall_jjjj: M.dynCall_jjjj,
  dynCall_jjjji: M.dynCall_jjjji,
  dynCall_jjjjiijii: M.dynCall_jjjjiijii,
  dynCall_jjjjj: M.dynCall_jjjjj,
  dynCall_jjjjji: M.dynCall_jjjjji,
  dynCall_jjjjjj: M.dynCall_jjjjjj,
  dynCall_viiiiiijji: M.dynCall_viiiiiijji,
  dynCall_viiiijjjij: M.dynCall_viiiijjjij,
  dynCall_viiijjji: M.dynCall_viiijjji,
  dynCall_viijj: M.dynCall_viijj,
  dynCall_viijjiiiiiiijiijiiiii: M.dynCall_viijjiiiiiiijiijiiiii,
  dynCall_vijjj: M.dynCall_vijjj,
  dynCall_vijjji: M.dynCall_vijjji,
  dynCall_vijjjij: M.dynCall_vijjjij,
  dynCall_vj: M.dynCall_vj,
  dynCall_vji: M.dynCall_vji,
  dynCall_vjii: M.dynCall_vjii,
  dynCall_vjiiii: M.dynCall_vjiiii,
  dynCall_vjiiiiiiiiiiijjiiijiiijijijjiiiiijiiiijj: M.dynCall_vjiiiiiiiiiiijjiiijiiijijijjiiiiijiiiijj,
  dynCall_vjiiiiiiiijjjjj: M.dynCall_vjiiiiiiiijjjjj,
  dynCall_vjiiiij: M.dynCall_vjiiiij,
  dynCall_vjiij: M.dynCall_vjiij,
  dynCall_vjiijiii: M.dynCall_vjiijiii,
  dynCall_vjiijj: M.dynCall_vjiijj,
  dynCall_vjij: M.dynCall_vjij,
  dynCall_vjijj: M.dynCall_vjijj,
  dynCall_vjijjjj: M.dynCall_vjijjjj,
  dynCall_vjj: M.dynCall_vjj,
  dynCall_vjji: M.dynCall_vjji,
  dynCall_vjjii: M.dynCall_vjjii,
  dynCall_vjjiii: M.dynCall_vjjiii,
  dynCall_vjjiiiijj: M.dynCall_vjjiiiijj,
  dynCall_vjjiiij: M.dynCall_vjjiiij,
  dynCall_vjjiiijj: M.dynCall_vjjiiijj,
  dynCall_vjjij: M.dynCall_vjjij,
  dynCall_vjjiji: M.dynCall_vjjiji,
  dynCall_vjjijj: M.dynCall_vjjijj,
  dynCall_vjjj: M.dynCall_vjjj,
  dynCall_vjjji: M.dynCall_vjjji,
  dynCall_vjjjii: M.dynCall_vjjjii,
  dynCall_vjjjiii: M.dynCall_vjjjiii,
  dynCall_vjjjijji: M.dynCall_vjjjijji,
  dynCall_vjjjj: M.dynCall_vjjjj,
  dynCall_vjjjji: M.dynCall_vjjjji,
  dynCall_vjjjjii: M.dynCall_vjjjjii,
  dynCall_vjjjjiij: M.dynCall_vjjjjiij,
  dynCall_vjjjjiijj: M.dynCall_vjjjjiijj,
  dynCall_vjjjjij: M.dynCall_vjjjjij,
  dynCall_vjjjjj: M.dynCall_vjjjjj,
} as const